<div
  style="
    display: flex;
    flex-direction: column;
    gap: 25px;
    margin-top: 20px;
    margin-left: 10px;
    margin-right: 10px;
  "
>
  <!-- Select Report Section -->
  <div style="order: 1; flex: 1">
    <p-card id="cdi-card-available-reports" header="Available Reports">
      <p-select
        id="cdi-dropdown-available-reports"
        placeholder="Available Reports"
        [options]="cache.reportConfigs"
        optionLabel="name"
        filter="true"
        fluid
        showClear="false"
        editable="false"
        (onChange)="onChangeAvailableReports($event.value)"
      ></p-select>
    </p-card>
  </div>
  <!-- Toolbar -->
  <div style="order: 2; flex: 1">
    <p-card id="cdi-card-report-parameters" header="Report Parameters">
      <div
        style="
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          align-content: center;
        "
      >
        <div
          style="order: 1; flex: 1; margin-bottom: 10px"
          *ngIf="reportConfiguration?.isAccountNumberRequired"
        >
          <!-- Dealer DropDownList-->
          <p-select
            id="cdi-dropdown-dealer-list"
            placeholder="Account Name"
            filter="true"
            fluid
            showClear="false"
            editable="false"
            [options]="cache.dealerListForReports"
            optionLabel="companyName"
            (onChange)="onChangeAccountName($event.value)"
          ></p-select>
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          align-content: center;
        "
      >
        <div
          style="order: 1; flex: 1"
          *ngIf="reportConfiguration?.showBeginDate"
        >
          <p-floatlabel variant="on">
            <p-datepicker
              id="cdi-datepicker-begin-date"
              dateFormat="yy-MM-dd"
              [showTime]="false"
              [readonlyInput]="this.reportConfiguration?.name == null"
              iconDisplay="input"
              inputId="cdi-datepicker-inputid-begin-date"
              showClear="false"
              (onSelect)="onSelectBeginDate($event)"
              [(ngModel)]="beginDate"
            />
            <label for="cdi-datepicker-inputid-begin-date">Begin Date</label>
          </p-floatlabel>
        </div>
        <div style="order: 2; flex: 1" *ngIf="reportConfiguration?.showEndDate">
          <p-floatlabel variant="on">
            <p-datepicker
              id="cdi-datepicker-end-date"
              dateFormat="yy-MM-dd"
              [showTime]="false"
              [readonlyInput]="this.reportConfiguration?.name == null"
              iconDisplay="input"
              inputId="cdi-datepicker-inputid-end-date"
              showClear="false"
              (onSelect)="onSelectEndDate($event)"
              [(ngModel)]="endDate"
            />
            <label for="cdi-datepicker-inputid-end-date">End Date</label>
          </p-floatlabel>
        </div>
        <div
          style="order: 3; flex: 1"
          *ngIf="reportConfiguration?.showPerformaCheckBox"
        >
          <p-checkbox
            id="cdi-checkbox-include-proforma"
            [binary]="true"
            [disabled]="reportConfiguration?.name == null"
            (onChange)="onChangeProformaCheckbox($event)"
            inputId="inputid-cdi-checkbox-include-proforma"
            [(ngModel)]="isProformaCheckboxChecked"
          />
          <label for="inputid-cdi-checkbox-include-proforma" class="ml-2"
            >&nbsp; Include Proforma</label
          >
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          align-content: center;
        "
        *ngIf="reportConfiguration?.showYearDropDown"
      >
        <div style="order: 1; flex: 1; margin-top: 10px">
          <!-- Year DropDownList-->
          <p-select
            id="cdi-dropdown-year-list"
            placeholder="Select Year"
            filter="true"
            fluid
            showClear="false"
            editable="false"
            optionLabel="year"
            [options]="cache.yearList"
            [readonly]="this.reportConfiguration?.name == null"
            (onChange)="onChangeYearList($event.value)"
          ></p-select>
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          align-content: center;
        "
        *ngIf="reportConfiguration?.showProductLineDropDown"
      >
        <div style="order: 1; flex: 1">
          <!-- ProductLine DropDownList-->
          <p-select
            id="cdi-dropdown-product-list"
            placeholder="Select Product Line"
            filter="true"
            fluid
            showClear="true"
            editable="false"
            [readonly]="reportConfiguration?.name == null"
            (onChange)="onChangeproductList($event.value)"
          ></p-select>
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          align-content: center;
        "
      >
        <div style="order: 1; flex: 90"></div>
        <div style="order: 2; flex: 10; margin-top: 5px">
          <p-button
            id="cdi-button-view-report"
            label="View Report"
            [disabled]="this.reportConfiguration?.name == null"
            (onClick)="onViewReportButtonClick()"
          />
        </div>
      </div>
    </p-card>
  </div>
  <!-- Report GRID-->
  <div style="order: 3; flex: 1">
    <p-card
      id="cdi-card-report"
      header="{{ reportConfiguration?.name ?? 'Report' }}"
    >
      <ag-grid-angular
        #cdiReportGrid
        style="width: 100%; height: 550px"
        (gridReady)="onGridReady($event)"
        [rowData]="reportData"
        [columnDefs]="columnDefinition"
        [pagination]="true"
        [rowGroupPanelShow]="rowGroupPanelShow"
      />
    </p-card>
  </div>
</div>
